import type { ReactElement } from 'react';

/**
 * The handset: "leave the typing and be on a call" — every door that opens a
 * voice telling wears it, and only those.
 *
 * One drawing, one file (2026-09-07). It used to be four: the chat page's
 * header door and the sign-in page's perk row each carried their own
 * serialisation of this same outline, the landing closer's contact card a
 * different handset altogether, and the three doors that actually lead to
 * /collect — the talk sheet, the landing dock, the /talk chooser — wore a
 * microphone instead. The microphone is the composer's dictation button (hold
 * and speak into the message you are writing); using it for a door that ends
 * the typing and starts a call said the wrong thing at the one moment the
 * person is choosing between the two.
 *
 * `size` is for surfaces that size their icons by attribute; omit it where the
 * stylesheet already sizes the svg (the dock's glyph chip, the landing card)
 * and nothing is written that CSS then has to override. `strokeWidth` stays
 * per-surface: optical weight belongs to the composition the glyph sits in,
 * not to the glyph.
 */
export function CallGlyph({ size, strokeWidth = 1.9, className }: {
  size?: number;
  strokeWidth?: number;
  className?: string;
}): ReactElement {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      {...(size ? { width: size, height: size } : {})}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" />
    </svg>
  );
}
